<app-modal-header [modalTitle]="title" [showCloseBtn]="true" (closeModal)="close()" />

<div *ngIf="loading" class="h-100 w-100 flex-center-all">
    <app-loader [loadingMessage]="loadingMessage" />
</div>

<div *ngIf="!loading" class="modal-content custom-vertical-scroll" [attr.loading]="loading" [attr.size]="'medium'">
    <form [formGroup]="ruleForm" (ngSubmit)="onSubmit()">
        <div class="form-fields-container">
            <mat-form-field class="col-5">
                <mat-label>Rule Name</mat-label>
                <input
                    matInput
                    [formControl]="name"
                    placeholder="Rule Name"
                    matTooltip="Please Enter A Rule Name"
                    matTooltipPosition="right"
                    matTooltipClass="right"
                />
                <mat-error *ngIf="name.hasError('required')"> Rule Name is required </mat-error>
                <mat-error *ngIf="name.hasError('unique')"> Rule Name must be unique </mat-error>
            </mat-form-field>
            <div>
                <mat-form-field class="col-5">
                    <mat-label>Description</mat-label>
                    <textarea
                        matInput
                        [formControl]="description"
                        rows="3"
                        matTooltip="Please Enter A Rule Description"
                        matTooltipPosition="right"
                        matTooltipClass="right"
                    ></textarea>
                </mat-form-field>
            </div>

            <h3>Conditions</h3>
            <app-action-condition-form
                #conditionsForm
                parentTypeName="Condition"
                [parentChoices]="config?.data?.conditions ?? []"
                tooltipText="Please select a Condition"
                [existingRuleArray]="config?.data?.rule?.conditions"
                (updateAllowedActions)="updateAllowedActions($event)"
                [sizes]="config?.data?.sizes"
            ></app-action-condition-form>
            <!-- <div formArrayName="conditions">
                <div *ngFor="let condition of conditions; let i = index" class="form-fields-span">
                    <mat-form-field class="col-5">
                        <mat-label>Condition</mat-label>
                        <input
                            matInput
                            type="text"
                            placeholder="Pick one"
                            [matAutocomplete]="conditionAutocomplete"
                            [formControl]="condition.formGroup.get('condition_name')"
                            (input)="onConditionInputChange($event, i)"
                            matTooltip="Please Select An Condition"
                            matTooltipPosition="right"
                            matTooltipClass="right"
                        />
                        <mat-autocomplete
                            #conditionAutocomplete="matAutocomplete"
                            (optionSelected)="onConditionSelected($event, i)"
                            requireSelection="true"
                            [displayWith]="displayConditionOptions"
                        >
                            <mat-option *ngFor="let option of filteredConditionChoices" [value]="option">
                                {{ option.condition_name }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="condition.formGroup.get('condition_name').hasError('required')">
                            Condition is required
                        </mat-error>
                    </mat-form-field>

                    <div class="col-4" *ngIf="condition.formGroup.contains('inputs')">
                        <div *ngFor="let input of condition.inputs">
                            <mat-form-field class="w-100" *ngIf="input.input_type !== 'boolean'">
                                <mat-label>{{ input.input_name }}</mat-label>
                                <div *ngIf="input.options">
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="Pick one"
                                        [matAutocomplete]="conditionValueAutocomplete"
                                        [formControl]="condition.formGroup.get('inputs').get(input.input_name)"
                                        (input)="onConditionInputValueChange($event, i, input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                    <mat-autocomplete
                                        #conditionValueAutocomplete="matAutocomplete"
                                        requireSelection="true"
                                    >
                                        <mat-option
                                            *ngFor="let option2 of getFilteredConditionInputOptions(i, input.input_name)"
                                            [value]="option2"
                                        >
                                            {{ option2 }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                                <div *ngIf="!input.options && input.input_type !== 'pct'">
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="Enter a value"
                                        [formControl]="condition.formGroup.get('inputs').get(input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                </div>
                                <div *ngIf="!input.options && input.input_type === 'pct'">
                                    <input
                                        matInput
                                        type="number"
                                        placeholder="Enter a percentage"
                                        [formControl]="condition.formGroup.get('inputs').get(input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                </div>
                                <mat-error
                                    *ngIf="condition.formGroup.get('inputs').get(input.input_name).hasError('required')"
                                >
                                    {{ input.input_name }} is required
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        condition.formGroup.get('inputs').get(input.input_name).hasError('invalidInteger')
                                    "
                                    >Value must be a positive integer
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        condition.formGroup.get('inputs').get(input.input_name).hasError('invalidFloat')
                                    "
                                    >Value must be a positive number
                                </mat-error>
                            </mat-form-field>
                            <div *ngIf="input.input_type === 'boolean'">
                                <mat-label>{{ input.input_name }}</mat-label>
                                <mat-checkbox [formControl]="condition.formGroup.get('inputs').get(input.input_name)" />
                            </div>
                        </div>
                    </div>

                    <button type="button" mat-button class="col-1" color="warn" (click)="removeCondition(i)">
                        Remove
                    </button>
                </div>
            </div> -->

            <h3>Actions</h3>
            <app-action-condition-form
                #actionsForm
                parentTypeName="Action"
                [parentChoices]="allowedActionChoices"
                tooltipText="Please select an Action"
                [existingRuleArray]="config?.data?.rule?.actions"
                [sizes]="config?.data?.sizes"
            ></app-action-condition-form>
            <!-- <div formArrayName="actions">
                <div *ngFor="let action of actions; let i = index" class="form-fields-span">
                    <mat-form-field class="col-5">
                        <mat-label>Action</mat-label>
                        <input
                            matInput
                            type="text"
                            placeholder="Pick one"
                            [matAutocomplete]="actionAutocomplete"
                            [formControl]="action.formGroup.get('action_name')"
                            (input)="onActionInputChange($event, i)"
                            matTooltip="Please Select An Action"
                            matTooltipPosition="right"
                            matTooltipClass="right"
                        />
                        <mat-autocomplete
                            #actionAutocomplete="matAutocomplete"
                            (optionSelected)="onActionSelected($event, i)"
                            requireSelection="true"
                            [displayWith]="displayActionOptions"
                        >
                            <mat-option *ngFor="let option of filteredActionChoices" [value]="option">
                                {{ option.action_title }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="action.formGroup.get('action_name').hasError('required')">
                            Action is required
                        </mat-error>
                    </mat-form-field>

                    <div class="col-4" *ngIf="action.formGroup.contains('inputs')">
                        <div *ngFor="let input of action.inputs">
                            <mat-form-field class="w-100" *ngIf="input.input_type !== 'boolean'">
                                <mat-label>{{ input.input_name }}</mat-label>
                                <div *ngIf="input.options">
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="Pick one"
                                        [matAutocomplete]="actionValueAutocomplete"
                                        [formControl]="action.formGroup.get('inputs').get(input.input_name)"
                                        (input)="onActionInputValueChange($event, i, input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                    <mat-autocomplete
                                        #actionValueAutocomplete="matAutocomplete"
                                        requireSelection="true"
                                    >
                                        <mat-option
                                            *ngFor="let option2 of getFilteredActionInputOptions(i, input.input_name)"
                                            [value]="option2"
                                        >
                                            {{ option2 }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                                <div *ngIf="!input.options && input.input_type !== 'pct'">
                                    <input
                                        matInput
                                        type="text"
                                        placeholder="Enter a value"
                                        [formControl]="action.formGroup.get('inputs').get(input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                </div>
                                <div *ngIf="!input.options && input.input_type === 'pct'">
                                    <input
                                        matInput
                                        type="number"
                                        placeholder="Enter a percentage"
                                        [formControl]="action.formGroup.get('inputs').get(input.input_name)"
                                        [matTooltip]="getToolTip(input)"
                                        matTooltipPosition="right"
                                        matTooltipClass="right"
                                    />
                                </div>
                                <mat-error
                                    *ngIf="action.formGroup.get('inputs').get(input.input_name).hasError('required')"
                                >
                                    {{ input.input_name }} is required
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        action.formGroup.get('inputs').get(input.input_name).hasError('invalidInteger')
                                    "
                                    >Value must be a positive integer
                                </mat-error>
                                <mat-error
                                    *ngIf="
                                        action.formGroup.get('inputs').get(input.input_name).hasError('invalidFloat')
                                    "
                                    >Value must be a positive number
                                </mat-error>
                            </mat-form-field>
                            <div *ngIf="input.input_type === 'boolean'">
                                <mat-label>{{ input.input_name }}</mat-label>
                                <mat-checkbox [formControl]="action.formGroup.get('inputs').get(input.input_name)" />
                            </div>
                        </div>
                    </div>

                    <button type="button" mat-button class="col-1" color="warn" (click)="removeAction(i)">
                        Remove
                    </button>
                </div>

                <button type="button" mat-button class="add-another" color="accent" (click)="addAction()">
                    Add Another Action
                </button>
            </div> -->

            <div class="form-fields-container-buttons">
                <mat-checkbox (click)="toggleRunRule()" color="accent" [checked]="runRule"> Run Rule </mat-checkbox>
            </div>
        </div>
    </form>
</div>

<app-modal-footer (closeModal)="close()" [closeBtnText]="'Close'" [showUpdateBtn]="false">
    <button
        type="submit"
        mat-raised-button
        color="accent"
        [disabled]="
            ruleForm.errors ||
            name.value === '' ||
            name.hasError('required') ||
            name.hasError('unique') ||
            actionsForm?.parentFormArray?.errors ||
            conditionsForm?.parentFormArray?.errors ||
            !actionsForm?.parents?.length ||
            !conditionsForm?.parents?.length ||
            saveDisabled
        "
        (click)="onSubmit()"
    >
        Save
    </button>
</app-modal-footer>
